import "@story/story_assets/dom_extend";
import { Animation } from "@story/story_assets/animations";

function findButton() {
	return document.querySelector(".ai-btn");
}

function findWindow() {
	return document.querySelector(".ai-window");
}

function showAiChat(id) {
	const screens = document.querySelectorAll("[data-ai-chat-id]");

	for (const screen of screens) {
		if (screen.getAttribute("data-ai-chat-id") == id) {
			screen.classList.remove("d-none");
		} else {
			screen.classList.add("d-none");
		}
	}
}


document.addEventSelectorListener("click", "[data-ai-chat-window='open']", async (event, target) => {
	event.preventDefault();

	const button = findButton();
	const window = findWindow();

	await Animation.fadeOut(button);
	Animation.fadeIn(window);
});

document.addEventSelectorListener("click", "[data-ai-chat-window='close']", async (event, target) => {
	event.preventDefault();

	const button = findButton();
	const window = findWindow();

	await Animation.fadeOut(window);
	Animation.fadeIn(button);
});

document.addEventSelectorListener("click", "[data-ai-chat]", async (event, target) => {
	event.preventDefault();

	const id = target.getAttribute("data-ai-chat");
	showAiChat(id);
});
